import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../store";
import AppSidebar from "../components/Layout/SideBar";
import AppHeader from "../components/Layout/Header";
import LeaveTracker from "../components/Modals/LeaveTracker";
import Logger from "../utils/logger";
import RoleValidator from "../utils/roleValidator";

function PrivateRoute() {
  const isAuthenticated = useAuth((state) => state.isAuthenticated);
  const getSecureRole = useAuth((state) => state.getSecureRole);

  // Double validation: check both auth state and token-based role
  const secureRole = getSecureRole();
  const hasValidRole = secureRole && secureRole !== "Default_Role";

  Logger.dev("isOnline: ", navigator.onLine);
  Logger.security(
    `PrivateRoute validation - authenticated: ${isAuthenticated}, role: ${secureRole}`
  );

  // If not authenticated OR no valid role from token, redirect to login
  if (!isAuthenticated || !hasValidRole) {
    Logger.security("PrivateRoute access denied - redirecting to login");
    RoleValidator.clearRoleCache(); // Clear any cached data
    return <Navigate to="/login" />;
  }

  return (
    <>
      <AppHeader />
      <div className="flex h-screen pt-[56px]">
        <AppSidebar />
        <LeaveTracker />
        <div className="flex-grow overflow-auto bg-[#f9f9f9]">
          <Outlet />
        </div>
      </div>
    </>
  );
}

export default PrivateRoute;
